var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.cancelFree)?_c('div',{staticClass:"notification is-success is-light"},[_vm._v(" You're in luck! This booking is eligible for free cancellation. ")]):_vm._e(),_c('p',[_vm._v(_vm._s(_vm.displayMessage))])])}
var staticRenderFns = []

export { render, staticRenderFns }